import { FeatureConfigKeys } from '@/utils/athena-feature-config';

import { useDeviceSupportsNativeExperience } from './useDeviceSupportsNativeExperience';

/**
 * Hook to check if customer's device supports native scrolling experience for long form content.
 * Supporting the native experience means that the device and app version meets the minimum version required.
 *
 * @returns boolean indicating if device supports native experience
 */
export const useDeviceSupportsNativeScrollingExperience = (): boolean => {
  return useDeviceSupportsNativeExperience(FeatureConfigKeys.ANDROID_VERSION_SUPPORTS_SCROLLING);
};
